import { gql } from '@apollo/client';

export const VIDEO_FILE_FIELDS = gql`
  fragment VideoFileFields on File {
    id
    title
    url
    videoId
    conceptId
  }
`;

export const VIDEO_FIELDS = gql`
  ${VIDEO_FILE_FIELDS}
  fragment VideoFields on Video {
    id
    demo
    status
    title
    museId
    startTime
    endTime
    thumbnail
    live
    description
    duration
    startTime
    endTime
    viewsToday
    views
    userViewed
    osceStation {
      id
      name
      hiddenName
    }
    concepts {
      id
      name
    }
    files {
      ...VideoFileFields
    }
  }
`;

// used in cache updator
export const VIDEO_STATUS_FRAGMENT = gql`
  fragment VideoStatus on Video {
    status
  }
`;

export const VIDEO_USER_VIEWED_FRAGMENT = gql`
  fragment VideoUserViewed on Video {
    userViewed
  }
`;
